/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileData/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Age from './Age/index'
import AgeGenderSeparator from './AgeGenderSeparator/index'
import DateOfBirth from './DateOfBirth/index'
import ExternalProfessionalInfo from './ExternalProfessionalInfo/index'
import Gender from './Gender/index'
import GenderBirthSeparator from './GenderBirthSeparator/index'
import HumanId from './HumanId/index'
import Name from './Name/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import Tag from './Tag/index'
import TysiaIconPersonFilled from 'DesignSystem/Svgs/TysiaIconPersonFilled/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
let Locations = React.lazy(() => import('./Locations/index'))



/** @type {import('Simple/types.js').View} */
export default function ProfileData({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileData"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let personIsPatientValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'is_patient',
})
let personIsExternalProfessionalValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'is_external_professional',
})
let personIsLeadValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'is_lead',
})
let aggregateData = fromAggregate.any(personIsPatientValueData, personIsExternalProfessionalValueData, personIsLeadValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<button
  data-testid="ProfileData.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--ml-2-2bfKmT': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--c-1-2bfKmT': aggregateData ? "pointer" : "default"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ProfileData.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Tag
  viewPath={`${viewPath}/Tag`}
/>
</div>
<div
  data-testid="ProfileData.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconPersonFilled
  viewPath={`${viewPath}/TysiaIconPersonFilled`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill={dtColorsNeutral600}
/>
<Age
  viewPath={`${viewPath}/Age`}
/>
<AgeGenderSeparator
  viewPath={`${viewPath}/AgeGenderSeparator`}
/>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<GenderBirthSeparator
  viewPath={`${viewPath}/GenderBirthSeparator`}
/>
<DateOfBirth
  viewPath={`${viewPath}/DateOfBirth`}
/>
<ExternalProfessionalInfo
  viewPath={`${viewPath}/ExternalProfessionalInfo`}
/>
</div>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<Locations
{...childProps}
  viewPath={`${viewPath}/Locations`}
/>
)}
</SuspenseBoundary>
<HumanId
  viewPath={`${viewPath}/HumanId`}
/>
</button>
{children}
</React.Fragment>)
}